<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <div class="wrapper-login-page">
      <div class="login-page login">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1>{{'LOGIN.login_to_your_account' | translate}}</h1>
          <h6>{{'NEW_TEXT.welcome_back_please_enter_your_details' | translate}}</h6>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmitLoginForm()" novalidate class="wrapper-content-auth">
          <div class="wrapper-input" [ngClass]="{'error': loginForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.' : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.email_address' | translate}}</span>
            <div class="custom-input">
              <input type="text" formControlName="email" placeholder="{{'NEW_TEXT.enter_you_email_address' | translate}}">
            </div>
            <div *ngIf="loginForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{loginForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}}</span>
            </div>
            <div class="wrapper-link-purple-60">
              <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.forgotEmailAndUsername.pagePath]">{{'LOGIN.i_need_help_with_username_or_email' | translate}}?</a>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': loginForm.controls['password'] | formControlErrorMessages: 'Wrong password, try again.': formTriedToSubmit}">
            <span class="label-input">{{'LOGIN.password' | translate}}</span>
            <div class="custom-input">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                placeholder="{{'NEW_TEXT.enter_password' | translate}}"
                formControlName="password">
              <img *ngIf="!isPasswordVisible" (click)="isPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
              <img *ngIf="isPasswordVisible" (click)="isPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
            </div>
            <div *ngIf="loginForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{loginForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
            <div class="wrapper-link-purple-60">
              <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.forgotPassword.pagePath]">{{'NEW_TEXT.forgot_password' | translate}}?</a>
            </div>
          </div>
          <button class="custom-btn custom-btn--primary">
            <span *ngIf="!isSpinnerActive">{{'GENERAL.login' | translate}}</span>
            <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
          </button>
          <span class="line-text">{{'NEW_TEXT.or_login_with' | translate}}</span>
          <div class="wrapper-social-login">
            <div class="item-social-login" (click)="signInWithGoogle()">
              <img src="../assets/icons/icon-google.svg" alt="">
              <span>{{'NEW_TEXT.google' | translate}}</span>
            </div>
            <!--            <div class="item-social-login">-->
<!--              <img src="../assets/icons/icon-facebook.svg" alt="">-->
<!--              <span>Facebook</span>-->
<!--            </div>-->
            <div class="item-social-login" (click)="signInWithApple()">
              <img src="../assets/icons/icon-apple.svg" alt="">
              <span>{{'NEW_TEXT.apple' | translate}}</span>
            </div>
          </div>
          <div class="wrapper-label-link">
            <span>{{'LOGIN.dont_have_an_account' | translate}}</span>
            <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.createAccount.pagePath]">{{'GENERAL.sign_up' | translate}}</a>
          </div>
        </form>
      </div>
      <div class="wrapper-sign-up-company-fixed">
        <div class="wrapper-btn-sign-up-company">
          <img src="../assets/icons/fill/icon-fill-company.svg" alt="">
          <span>{{'LOGIN.for_companies' | translate}}</span>
          <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.createCompanyAccount.pagePath]">{{'GENERAL.sign_up' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
